import { Action } from '@ngrx/store';
import { IExpType } from '../../../../commons';

export enum ExpTypeActionTypes {
  LoadExpTypeState = '[ExpType] Load ExpType State',
  LoadExpTypeStateSuccess = '[ExpType] Load ExpType State Success',
  LoadExpTypeStateFail = '[ExpType] Load ExpType State Fail',
  ExpTypeScreenErrorReset = '[ExpType] ExpType Screen Error Reset'

}

export class LoadExpTypeState implements Action {
  readonly type = ExpTypeActionTypes.LoadExpTypeState;
}

export class LoadExpTypeStateSuccess implements Action {
  readonly type = ExpTypeActionTypes.LoadExpTypeStateSuccess;
  constructor(public payload: IExpType ) {}
}

export class LoadExpTypeStateFail implements Action {
  readonly type = ExpTypeActionTypes.LoadExpTypeStateFail;
  constructor(public payload: any) {}
}

export class ExpTypeScreenErrorReset implements Action {
  readonly type = ExpTypeActionTypes.ExpTypeScreenErrorReset;
}

export type ExpTypeActions = 
  LoadExpTypeState
  | LoadExpTypeStateSuccess
  | LoadExpTypeStateFail
  | ExpTypeScreenErrorReset;